import { jsx as _jsx } from "react/jsx-runtime";
import { Cell, Grid } from '@phishtool/ui';
import { StyledErrorWrapper } from './styled';
import { Heading } from '~components/heading';
const defaultMessage = 'Oops, something went wrong.';
const ErrorComponent = ({ message = defaultMessage }) => (_jsx(StyledErrorWrapper, { children: _jsx(Grid, { children: _jsx(Cell, { children: _jsx(Heading, { color: "white", align: "center", spacer: "x0", children: message }) }) }) }));
export default ErrorComponent;
